module.exports = __webpack_public_path__ + "static/media/WA3F2040.6f210f49.svg";